function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 70,
  r: 70,
  fill: "#0085FF",
  fillOpacity: 0.08
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#empty-groups-state_svg__filter0_d_961:34)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 49,
  width: 166,
  height: 37,
  rx: 1.532,
  fill: "#fff"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0085FF",
  fillOpacity: 0.1,
  d: "M36 54h128v6H36z"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 78,
  r: 14,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 78,
  r: 13,
  fill: "#DBDFE5"
});
var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-groups-state_svg__a)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 91,
  r: 13
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 73.864,
  r: 6.275,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 79.432,
  cy: 78,
  r: 14,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 79.432,
  cy: 78,
  r: 13,
  fill: "#DBDFE5"
});
var _ref9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-groups-state_svg__b)",
  fill: "#A0AFBE"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 79.432,
  cy: 91,
  r: 13
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79.432,
  cy: 73.864,
  r: 6.275,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref0 = /*#__PURE__*/React.createElement("circle", {
  cx: 100.432,
  cy: 78,
  r: 14,
  fill: "#DBDFE5",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref1 = /*#__PURE__*/React.createElement("circle", {
  cx: 100.432,
  cy: 78,
  r: 13,
  fill: "#DBDFE5"
});
var _ref10 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#empty-groups-state_svg__c)",
  fill: "#0085FF"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 100.432,
  cy: 91,
  r: 13
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100.432,
  cy: 73.864,
  r: 6.275,
  stroke: "#DBDFE5",
  strokeWidth: 1.914
}));
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M44.813 77.937H36v-3.063",
  stroke: "#A0AFBE",
  strokeWidth: 1.217,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M41.625 81L45 77.937l-3.375-3.063",
  stroke: "#A0AFBE",
  strokeWidth: 1.217,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "empty-groups-state_svg__filter0_d_961:34",
  x: 22,
  y: 43,
  width: 182,
  height: 53,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_961:34"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_961:34",
  result: "shape"
})));
function SvgEmptyGroupsState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 140,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, /*#__PURE__*/React.createElement("mask", {
    id: "empty-groups-state_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 65,
    width: 26,
    height: 26
  }, _ref5), _ref6, _ref7, /*#__PURE__*/React.createElement("mask", {
    id: "empty-groups-state_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 65,
    width: 27,
    height: 26
  }, _ref8), _ref9, _ref0, /*#__PURE__*/React.createElement("mask", {
    id: "empty-groups-state_svg__c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 65,
    width: 27,
    height: 26
  }, _ref1), _ref10, _ref11, _ref12, _ref13);
}
export default SvgEmptyGroupsState;